@if (displayInformationBanner && currentUser.organisationId === currentOrg) {
  <div id="toast">
    <app-toast
      [toastStyle]="informationBannerType"
      [icon]="informationBannerIcon"
      [text]="informationBannerMessage"
    >
    </app-toast>
  </div>
}
@if (showRecoveryCodesWarning && !displayInformationBanner) {
  <div id="recovery-codes-toast">
    <app-toast
      toastStyle="warning"
      icon="warning"
      [text]="recoveryCodesRemainingCount + ' recovery codes remaining. Go to account settings to generate new codes.'"
    ></app-toast>
  </div>
}
@if (canAccessLab) {
  <div id="dashboard--container">
    <div id="header--container">
      <h4>Welcome to your dashboard.</h4>
      <h5>{{ laboratory?.laboratoryName }}</h5>
    </div>
    <hr class="alt" />
    <div id="nav--container">
      <div class="button-one--container">
        <app-option-tab-toggle
          id="toggle--container"
          radioGroup="navigationToggle"
          [selectOptions]="navOptions"
          type="round"
        >
        </app-option-tab-toggle>
        <app-mat-fab-button
          buttonStyle="success"
          iconName="refresh"
          (buttonClicked)="getDevices(true)"
          ariaLabel="Refresh"
          [animateSpinner]="reloadButtonProcessing"
        ></app-mat-fab-button>
      </div>
      <div class="button-two--container">
        <app-search-field
          [field]="searchField"
          [parentForm]="deviceTableControls"
          (buttonClicked)="handleSearch($event)"
        >
        </app-search-field>
        <app-icon-button
          label="filters"
          buttonStyle="secondary"
          buttonId="filter-btn"
          iconName="filter_list"
          buttonShape="square"
          (buttonClicked)="openModal('filter')"
          title="Filters"
        ></app-icon-button>
        <app-mat-fab-button
          buttonStyle="accent"
          iconName="science"
          (buttonClicked)="onNewExperiment()"
          ariaLabel="New experiment"
          [isDisabled]="
            !(currentUser.role
              | roleCheck: editAccessRoles)
          "
        ></app-mat-fab-button>
        <app-mat-fab-button
          buttonStyle="accent"
          iconName="timeline"
          (buttonClicked)="onNewCalibration()"
          ariaLabel="New calibration"
          [isDisabled]="
            selectedDeviceList?.length > 1 || !(currentUser.role
              | roleCheck: editAccessRoles)
          "
        ></app-mat-fab-button>
      </div>
    </div>
    @if (devices?.length > 0) {
      <div id="inner-page--container">
        <p id="table-description" style="display: none">Device summary table</p>
        <div id="table--container">
          <table aria-describedby="table-description">
            <thead>
              <tr>
                <th
                  id="device"
                  scope="col"
                  (click)="onSort('Name')"
                  [class.active]="currentSort.sortBy === 'Name'"
                >
                  <div id="table-header">
                    <span>Device</span>
                    <mat-icon
                      aria-label="sort direction"
                      matTooltip="Sort direction"
                      >swap_vert</mat-icon
                    >
                  </div>
                </th>
                <th
                  id="status"
                  scope="col"
                  (click)="onSort('DeviceStatusId')"
                  [class.active]="currentSort.sortBy === 'DeviceStatusId'"
                >
                  <div id="table-header">
                    <span>Status</span>
                    <mat-icon
                      aria-label="sort direction"
                      matTooltip="Sort direction"
                      >swap_vert</mat-icon
                    >
                  </div>
                </th>
                <th
                  id="experiment"
                  scope="col"
                  (click)="onSort('ExperimentName')"
                  [class.active]="currentSort.sortBy === 'ExperimentName'"
                >
                  <div id="table-header">
                    <span>Experiment</span>
                    <mat-icon
                      aria-label="sort direction"
                      matTooltip="Sort direction"
                      >swap_vert</mat-icon
                    >
                  </div>
                </th>
                <th id="view" scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (device of devices; track device.id) {
                <tr>
                  <td headers="device">
                    <div id="device-name--container">
                      {{ device.name }}
                    </div>
                    <app-active-modules
                      [activeModules]="device.deviceModules"
                    ></app-active-modules>
                  </td>
                  <td headers="status" id="device-cell">
                    @if (device) {
                      <div>
                        <app-status-indicator
                          [status]="DeviceSetupStatus[device.deviceStatusId]"
                          [isOffline]="device.isOffline"
                        ></app-status-indicator>
                      </div>
                      <div id="device-cell--icons">
                        @if (!device.isOffline) {
                          <mat-icon
                            class="positive"
                            aria-label="online"
                            matTooltip="Online"
                            >wifi</mat-icon
                          >
                        }
                        @if (device.isOffline) {
                          <mat-icon
                            class="error"
                            aria-label="offline"
                            matTooltip="Offline"
                            >wifi_off</mat-icon
                          >
                        }
                        <app-software-status-icon
                          [softwareWarning]="device?.softwareWarning"
                        />
                        @if (device?.isOffline) {
                          <mat-icon
                            class="out-of-sync"
                            aria-label="Device out of sync"
                            matTooltip="Device out of sync"
                            >cloud_off</mat-icon
                          >
                        }
                        @if (!device?.isOffline) {
                          <mat-icon
                            class="positive"
                            fontSet="material-icons-outlined"
                            aria-label="Device in sync"
                            matTooltip="Device in sync"
                            >cloud</mat-icon
                          >
                        }
                      </div>
                    }
                  </td>
                  <td headers="experiment" class="wrap-text">
                    <div>
                      {{ device.experiment?.name || "No experiment assigned" }}
                    </div>
                    <div>
                      @if (
                        ((device?.deviceStatusId === DeviceSetupStatus.Active ||
                          device?.deviceStatusId ===
                            DeviceSetupStatus.Paused) &&
                          device?.experiment?.experimentStatusId === ExperimentStatus.Active) &&
                        (currentTime$ | async); as currentTime
                      ) {
                        @let timeLeft = getTimeLeft(
                          device.experiment?.startTime,
                          device.experiment?.duration,
                          currentTime
                        );
                        @if (timeLeft) {
                          Time left:
                          {{ timeLeft.days | number: "2.0" }}:{{ timeLeft.hours | number: "2.0" }}:{{ timeLeft.minutes | number: "2.0" }}:{{ timeLeft.seconds | number: "2.0" }}
                        } @else {
                          Couldn't calculate time remaining
                        }
                      }
                    </div>
                  </td>
                  <td headers="view" id="view-cell">
                    <div class="button--container">
                      <app-mat-outlined-button
                        label="View Device"
                        ariaLabel="View Device"
                        [buttonId]="'device_' + device?.id"
                        iconName="arrow_forward"
                        iconPosition="right"
                        (buttonClicked)="onViewDeviceDetails(device.id)"
                      >
                      </app-mat-outlined-button>
                      <!-- Calibration buttons -->
                      @switch (device?.deviceStatusId) {
                        @case (DeviceSetupStatus.ActiveODCalibration) {
                          @if (device.odCalibrationId != null) {
                            <app-mat-outlined-button
                              label="View Active Calibration"
                              ariaLabel="View Active OD Calibration"
                              iconName="arrow_forward"
                              iconPosition="right"
                              [buttonId]="
                                'calibration_' + device?.odCalibrationId
                              "
                              [routerLink]="
                                '/calibration/optical-density/' +
                                device?.odCalibrationId +
                                '/calibration-data'
                              "
                            >
                            </app-mat-outlined-button>
                          }
                        }
                        @case (DeviceSetupStatus.ActiveOxygenCalibration) {
                          @if (
                            device.oxygenCalibrationId != null
                          ) {
                            <app-mat-outlined-button
                              label="View Active Calibration"
                              ariaLabel="View Active Oxygen Calibration"
                              iconName="arrow_forward"
                              iconPosition="right"
                              [buttonId]="
                                'calibration_' + device?.oxygenCalibrationId
                              "
                              [routerLink]="
                                '/calibration/oxygen/' +
                                device?.oxygenCalibrationId +
                                '/calibration-data'
                              "
                            >
                            </app-mat-outlined-button>
                          }
                        }
                        @case (DeviceSetupStatus.ActivePHCalibration) {
                          @if (device.phCalibrationId != null) {
                            <app-mat-outlined-button
                              label="View Active Calibration"
                              ariaLabel="View Active PH Calibration"
                              iconName="arrow_forward"
                              iconPosition="right"
                              [buttonId]="
                                'calibration_' + device?.phCalibrationId
                              "
                              [routerLink]="
                                '/calibration/ph/' +
                                device?.phCalibrationId +
                                '/calibration-data'
                              "
                            >
                            </app-mat-outlined-button>
                          }
                        }
                        @case (DeviceSetupStatus.ActiveSpargingCalibration) {
                          @if (
                            device.spargingCalibrationId != null
                          ) {
                            <app-mat-outlined-button
                              label="View Active Calibration"
                              ariaLabel="View Active Sparging Calibration"
                              iconName="arrow_forward"
                              iconPosition="right"
                              [buttonId]="
                                'calibration_' + device?.spargingCalibrationId
                              "
                              [routerLink]="
                                '/calibration/sparging/' +
                                device?.spargingCalibrationId +
                                '/calibration-data'
                              "
                            >
                            </app-mat-outlined-button>
                          }
                        }
                        @case (DeviceSetupStatus.Awaiting) {
                          @if (
                            device?.experiment?.experimentStatusId ===
                            ExperimentStatus.DraftLocked
                          ) {
                            <app-mat-outlined-button
                              label="Setup devices"
                              ariaLabel="Setup devices"
                              iconName="arrow_forward"
                              iconPosition="right"
                              [buttonId]="
                                'experiment_' + device?.experiment?.id
                              "
                              [routerLink]="
                                '/experiment/' +
                                device?.experiment?.id +
                                '/device-setup'
                              "
                              [isDisabled]="
                                !(currentUser.role | roleCheck: runAccessRoles)
                              "
                            >
                            </app-mat-outlined-button>
                          }
                        }
                        @case (DeviceSetupStatus.FlasksInserted) {
                          @if (
                            device?.experiment?.experimentStatusId ===
                            ExperimentStatus.DraftLocked
                          ) {
                            <app-mat-outlined-button
                              label="Setup devices"
                              ariaLabel="Setup devices"
                              iconName="arrow_forward"
                              iconPosition="right"
                              [buttonId]="
                                'experiment_' + device?.experiment?.id
                              "
                              [routerLink]="
                                '/experiment/' +
                                device?.experiment?.id +
                                '/device-setup'
                              "
                              [isDisabled]="
                                !(currentUser.role | roleCheck: runAccessRoles)
                              "
                            >
                            </app-mat-outlined-button>
                          }
                          @if (
                            device?.experiment?.experimentStatusId ===
                            ExperimentStatus.Active
                          ) {
                            <app-mat-outlined-button
                              label="Go to experiment"
                              ariaLabel="Go to experiment"
                              iconName="arrow_forward"
                              iconPosition="right"
                              [buttonId]="
                                'experiment_' + device?.experiment?.id
                              "
                              [routerLink]="
                                '/experiment/' +
                                device?.experiment?.id +
                                '/display'
                              "
                            >
                            </app-mat-outlined-button>
                          }
                        }
                        @case (DeviceSetupStatus.Active) {
                          @if (device?.experiment) {
                            <app-mat-outlined-button
                              label="View Experiment"
                              ariaLabel="View Experiment"
                              [buttonId]="
                                'experiment_' + device?.experiment?.id
                              "
                              iconName="arrow_forward"
                              iconPosition="right"
                              [routerLink]="
                                '/experiment/' +
                                device?.experiment?.id +
                                '/display'
                              "
                            >
                            </app-mat-outlined-button>
                          }
                        }
                        @case (DeviceSetupStatus.Paused) {
                          @if (device?.experiment) {
                            <app-mat-outlined-button
                              label="View Experiment"
                              ariaLabel="View Experiment"
                              [buttonId]="
                                'experiment_' + device?.experiment?.id
                              "
                              iconName="arrow_forward"
                              iconPosition="right"
                              [routerLink]="
                                '/experiment/' +
                                device?.experiment?.id +
                                '/display'
                              "
                            >
                            </app-mat-outlined-button>
                          }
                        }
                        @case (DeviceSetupStatus.Complete) {
                          @if (device?.experiment) {
                            <app-mat-outlined-button
                              label="View Experiment"
                              ariaLabel="View Experiment"
                              [buttonId]="
                                'experiment_' + device?.experiment?.id
                              "
                              iconName="arrow_forward"
                              iconPosition="right"
                              [routerLink]="
                                '/experiment/' +
                                device?.experiment?.id +
                                '/display'
                              "
                            >
                            </app-mat-outlined-button>
                          }
                        }
                      }
                      @if (
                        device?.experiment?.experimentStatusId ===
                        ExperimentStatus.Draft
                      ) {
                        <app-mat-outlined-button
                          label="Start Experiment"
                          ariaLabel="Start Experiment"
                          [buttonId]="'experiment_' + device?.experiment?.id"
                          iconName="arrow_forward"
                          iconPosition="right"
                          [routerLink]="
                            '/experiment/' +
                            device?.experiment?.id +
                            '/set-parameters'
                          "
                          [isDisabled]="
                            !(currentUser.role | roleCheck: runAccessRoles)
                          "
                        >
                        </app-mat-outlined-button>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <div id="table-footer">
            <div>
              <span class="body1">
                Page refreshed:
                {{ deviceListLastUpdated | date: "HH:mm a" }}
              </span>
            </div>
            <div id="pagination--container">
              <div class="filter--container">
                <label for="devices-per-page">Devices per page</label>
                <app-dropdown-form-field
                  id="devices-per-page"
                  [field]="devicesPerPageField"
                  [parentForm]="deviceTableControls"
                >
                </app-dropdown-form-field>
              </div>
              <div id="pagination--controls">
                <app-icon-button
                  iconName="chevron_left"
                  buttonId="previous"
                  (buttonClicked)="getPrevious()"
                  [isDisabled]="!hasPrevious"
                ></app-icon-button>
                <span> {{ currentPage }} / {{ totalPages }} </span>
                <app-icon-button
                  iconName="chevron_right"
                  buttonId="next"
                  (buttonClicked)="getNext()"
                  [isDisabled]="!hasNext"
                ></app-icon-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (!loading && (!devices || devices.length === 0)) {
      <div id="cta--container">
        <h4>No devices detected</h4>
        <app-icon-button
          label="reset"
          buttonStyle="secondary"
          buttonId="filter-btn"
          iconName="refresh"
          buttonShape="square"
          (buttonClicked)="resetForm()"
        ></app-icon-button>
        @if (error) {
          <p class="error">Error: {{ error.message }}</p>
        }
        @if (!devices) {
          <section id="button--container">
            <app-button
              label="Add New Device"
              buttonId="new-device-btn"
              [routerLink]="'/device/create-device'"
              [isDisabled]="!(currentUser.role | roleCheck: labAdminRoles)"
            >
            </app-button>
          </section>
        }
      </div>
    }
    @if (loading && !devices) {
      <div id="loading--container">
        <app-loading-spinner></app-loading-spinner>
      </div>
    }
  </div>
} @else if (showLabIntro) {
  <div id="create-lab--container">
    <div id="left--container">
      <img src="assets/img/ogi-logo-tagline.png" alt="OGI logo" />
    </div>
    <div id="right--container">
      <h4>Let's get started</h4>
      <div class="step">
        <div class="circle">1</div>
        <p class="subtitle2">Create a laboratory</p>
        <app-mat-icon-button
          buttonStyle="primary"
          iconName="arrow_forward"
          ariaLabel="Create a laboratory"
          (buttonClicked)="dashboardButtonClicked('add-lab')"
        ></app-mat-icon-button>
      </div>
      <div class="step">
        <div class="circle">2</div>
        <p class="subtitle2">Join the laboratory</p>
        <app-mat-icon-button
          buttonStyle="primary"
          iconName="arrow_forward"
          ariaLabel="Join laboratory"
          (buttonClicked)="dashboardButtonClicked('join-lab')"
        ></app-mat-icon-button>
      </div>
      <p class="body top">
        If you would like to add devices, create experiments, create
        calibrations and view experiment/device data you must join the
        laboratory. If you would just like to be able to add users, you can skip
        this step.
      </p>
      <p class="body">
        If you decide you want to join the laboratory at a later date, you can
        add yourself as a member on the 'view lab' page.
      </p>
      <div class="step">
        <div class="circle">3</div>
        <p class="subtitle2">Add users to the laboratory</p>
        <app-mat-icon-button
          buttonStyle="primary"
          iconName="arrow_forward"
          ariaLabel="Add user to laboratory"
          (buttonClicked)="dashboardButtonClicked('add-users')"
        ></app-mat-icon-button>
      </div>
      <!-- Disabled if super user is not a member of the lab -->
      <div [class]="!laboratory?.isOwnLab ? 'step disabled' : 'step'">
        <div class="circle">4</div>
        <p class="subtitle2">Add devices to the laboratory</p>
        <app-mat-icon-button
          buttonStyle="primary"
          iconName="arrow_forward"
          ariaLabel="Add devices to laboratory"
          [isDisabled]="!laboratory?.isOwnLab"
          (buttonClicked)="dashboardButtonClicked('add-device')"
        ></app-mat-icon-button>
      </div>
      <p class="body top">
        You can only add devices if you are a member the laboratory.
      </p>
      <p class="help-text">
        You can go back to this page at any time by clicking
        <a href="./help">Help</a> in the menu.
      </p>
    </div>
  </div>
} @else {
  <app-error-page
    title="You are not a member of this lab"
    primaryText="Sorry, you cannot access this page unless you are a member of a lab"
  ></app-error-page>
}
<app-filter-modal
  id="filter"
  primaryButtonText="Apply Filters"
  primaryButtonId="continue-button"
  secondaryButtonText="Reset"
  secondaryButtonId="reset-button"
  [modulesField]="deviceModuleFilters"
  [statusField]="deviceStatusFilters"
  [offlineField]="deviceOfflineField"
  [deletedField]="includeDeletedDevicesField"
  [parentForm]="deviceTableControls"
  [hideDeletedField]="!(currentUser.role | roleCheck: ogiSuperAdminOnly)"
  (modalButtonClicked)="modalButtonClicked($event)"
  (moduleCheckboxClicked)="moduleCheckboxClicked($event)"
  [isProcessing]="loading"
></app-filter-modal>
